module.exports = __webpack_public_path__ + "static/img/Trees.ce3f2b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/banners/Trees.png
// module id = 2245
// module chunks = 61